import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink, Redirect } from 'react-router-dom'
import { Row, Col, Button, Dropdown, Icon, Menu, Radio, Tabs, Tooltip } from 'antd'
import moment from 'moment'
import _ from 'lodash'
import { parse } from 'qs'
import cx from 'classnames'

import * as actions from './ProjectDocumentPageActions'
import * as totalCalculator from '../utils/totalCalculator'
import PaymentBlock from '../Commons/PaymentBlock/PaymentBlock'
import BackgroundInformationForm from '../Commons/BackgroundInformationForm/BackgroundInformationForm'
import DocumentContentForm from '../Commons/DocumentContentForm/DocumentContentForm'
import TermsAndConditionsForm from '../Commons/TermsAndConditionsForm/TermsAndConditionsForm'
import PaymentInvoiceTable from '../Commons/PaymentInvoiceTable/PaymentInvoiceTable'
import RemarksForm from '../Commons/RemarksForm/RemarksForm'
import AppendixList from '../Commons/AppendixList/AppendixList'
import IrreversibleCheckbox from '../Commons/IrreversibleCheckbox/IrreversibleCheckbox'
import IrreversibleButton from '../Commons/IrreversibleButton/IrreversibleButton'
import QuotationItemListModal from '../Commons/QuotationItemListModal/QuotationItemListModal'
import DocumentSelectModal from '../Commons/DocumentSelectModal/DocumentSelectModal'
import DueDateModal from '../Commons/DueDateModal/DueDateModal'
import ExportModal from '../Commons/ExportModal/ExportModal'
import TempalteExportModal from '../Commons/TemplateExportModal/TemplateExportModal'
import GenerateWPReportModal from '../Commons/GenerateWPReportModal/GenerateWPReportModal'
import ProjectSummaryModal from '../Commons/ProjectSummaryModal/ProjectSummaryModal'
import QSTableSelectImportModal from '../Commons/QSTableSelectImportModal/QSTableSelectImportModal'
import './ProjectDocumentPage.scss'

const MenuItem = Menu.Item
const RadioGroup = Radio.Group
const TabPane = Tabs.TabPane
const { getGrandTotal } = totalCalculator

export class ProjectDocumentPage extends Component {
    constructor(props) {
        super(props)

        const query = parse(props.location.search.substr(1))
        const docType = location.pathname === '/workdesk/project/new' ? 'quotation' : query.type
        const { selectedProject } = props
        const { code, name, type, category, size, client_name, company_name, client_number, client_email, contact_person, handled_by, handled_by_name, handled_by_number, flat, floor, estate_name, site_location, site_address } = selectedProject
        const backgroundInformation = { code, name, type, category, size, client_name, company_name, client_number, client_email, contact_person, handled_by, handled_by_name, handled_by_number, flat, floor, estate_name, site_location, site_address }

        this.state = {
            selectedKey: '',
            backgroundInformation: _.isEmpty(selectedProject) ? { category: "RE" } : backgroundInformation,
            name: docType ? 'New ' + _.startCase(docType) : '',
            type: docType,
            sent: false,
            confirmed: false,
            voided: false,
            createdAt: '',
            contactPerson: '',
            discounts: [],
            grandTotal: 0,
            sections: [],
            noticeSections: {
                items: []
            },
            termsAndConditions: {
                commencementDate: '',
                workingPeriod: 0,
                workingPeriodRemark: '',
                payments: [],
                sections: []
            },
            remarks: [],
            appendix: [],
            mainQuotation: {},
            isProjectBackgroundChange: false,
            isDocumentContentChange: false,
            showTemplateListModal: false,
            showQuotationItemListModal: false,
            showDocumentSelectModal: false,
            showTemplateBackgroundListModal: false,
            importContent: true,
            importTAndC: true,
            smartSaerchFilter: {},
            redirectTo: '',
            isMenuOpened: false
        }

        this.handleTemplateExport = this.handleTemplateExport.bind(this)
        this.openProjectListModal = this.openProjectListModal.bind(this)
        this.closeProjectListModal = this.closeProjectListModal.bind(this)
        this.openQuotationItemListModal = this.openQuotationItemListModal.bind(this)
        this.closeQuotationItemListModal = this.closeQuotationItemListModal.bind(this)
        this.openTemplateListModal = this.openTemplateListModal.bind(this)
        this.closeTemplateListModal = this.closeTemplateListModal.bind(this)
        this.openDocumentSelectModal = this.openDocumentSelectModal.bind(this)
        this.closeDocumentSelectModal = this.closeDocumentSelectModal.bind(this)
        this.openTemplateBackgroundListModal = this.openTemplateBackgroundListModal.bind(this)
        this.closeTemplateBackgroundListModal = this.closeTemplateBackgroundListModal.bind(this)
        this.handleQuotationItemListSubmit = this.handleQuotationItemListSubmit.bind(this)
        this.handleImportBackgroundMenuSelect = this.handleImportBackgroundMenuSelect.bind(this)
        this.handleImportMenuSelect = this.handleImportMenuSelect.bind(this)
        this.handleNewDocumentTypeChange = this.handleNewDocumentTypeChange.bind(this)
        this.handleDocumentStatusChange = this.handleDocumentStatusChange.bind(this)
        this.handleDocumentSave = this.handleDocumentSave.bind(this)
        this.handleDocumentExport = this.handleDocumentExport.bind(this)
        this.handleDocumentVoid = this.handleDocumentVoid.bind(this)
        this.handleProjectSummaryModalOpen = this.handleProjectSummaryModalOpen.bind(this)
        this.updatePaymentAmount = this.updatePaymentAmount.bind(this)
    }

    updatePaymentAmount() {
        const { grandTotal, termsAndConditions } = this.state
        let newTermsAndConditions = _.cloneDeep(termsAndConditions)

        newTermsAndConditions.payments = _.map(newTermsAndConditions.payments, (payment) => ({ ...payment, amount: payment.percentage ? +(grandTotal * payment.percentage / 100).toFixed(1) : payment.amount }))

        this.setState({ termsAndConditions: newTermsAndConditions })
    }

    // Modals - Project Summary
    handleProjectSummaryModalOpen() {
        const { fetchProjectSummary, token, selectedProject } = this.props
        const projectId = selectedProject._id

        fetchProjectSummary(token, projectId)
    }

    // Modals - Export PDF
    handlePDFExport(projectId, documentId, type, paymentId) {
        const { exportPDF, token } = this.props
        exportPDF(token, projectId, documentId, type, paymentId)
    }

    // Modals - Export Template
    handleTemplateExport(name) {
        const { saveTemplate, token } = this.props
        const { backgroundInformation, sections, discounts, grandTotal, termsAndConditions } = this.state
        const { client_name, company_name, client_email, client_number, category, type, size, estate_name, site_location, site_address, flat, floor } = backgroundInformation

        saveTemplate(token, { name, client_name, company_name, client_email, client_number, category, type, size, estate_name, site_location, site_address, flat, floor }, { sections, discounts, grandTotal }, { payments: termsAndConditions.payments, sections: termsAndConditions.sections })
    }

    // Modals - Generate WPR
    handleGenerateWPReportModalSubmit(newSections, newNoticeSections) {
        const { createWPR, token, selectedProject, selectedProjectDocument } = this.props
        const { name, type, sent, confirmed, grandTotal, backgroundInformation, sections, noticeSections, discounts, termsAndConditions, remarks, appendix } = this.state
        const projectId = selectedProject._id
        const documentId = selectedProjectDocument._id

        createWPR(token, projectId, newSections, newNoticeSections, documentId, { name, type, sent, confirmed, grandTotal, backgroundInformation, sections, noticeSections, discounts, termsAndConditions, remarks, appendix })
    }

    // Modals - Import Items From Main Quotation
    openQuotationItemListModal() {
        const { fetchMainQuotation, token, selectedProject } = this.props
        const projectId = selectedProject._id

        fetchMainQuotation(token, projectId)

        this.setState({ showQuotationItemListModal: true })
    }

    closeQuotationItemListModal() {
        this.setState({ showQuotationItemListModal: false })
    }

    handleMainQuotationItemCheck(sectionIdx, itemIdx) {
        let newMainQuotation = _.cloneDeep(this.state.mainQuotation)
        newMainQuotation.sections[sectionIdx].items[itemIdx].checked = !newMainQuotation.sections[sectionIdx].items[itemIdx].checked
        this.setState({ mainQuotation: newMainQuotation })
    }

    handleQuotationItemListSubmit() {
        const { sections, mainQuotation } = this.state
        let newSections = _.cloneDeep(sections)
        _.map(mainQuotation.sections, (section, sectionIdx) => {
            let checkedItem = _.find(section.items, { checked: true })
            if (!_.isEmpty(checkedItem)) {
                let targetSection = _.find(newSections, { name: section.name })
                if (_.isEmpty(targetSection)) {
                    newSections.push({
                        original_idx: sectionIdx,
                        name: section.name,
                        items: []
                    })
                    targetSection = _.find(newSections, { name: section.name })
                }
                _.map(section.items, (item, itemIdx) => {
                    if (item.checked && _.isEmpty(_.find(targetSection.items, { name: item.name }))) {
                        let { checked, ...newItem } = item
                        newItem.original_idx = itemIdx
                        targetSection.items.push(newItem)
                    }
                })
            }
        })

        this.setState({ sections: newSections, showQuotationItemListModal: false })
    }

    // Modals - Import from Template List
    openTemplateListModal() {
        const { fetchTemplateList, token } = this.props

        fetchTemplateList(token)

        this.setState({ showTemplateListModal: true })
    }

    closeTemplateListModal() {
        this.setState({ showTemplateListModal: false })
    }

    handleTemplateModalSubmit(templateId) {
        const { fetchTemplateContent, token } = this.props

        fetchTemplateContent(token, templateId)

        this.setState({ showTemplateListModal: false })
    }

    // Modals - Import Background Information from Template List
    openTemplateBackgroundListModal() {
        const { fetchTemplateList, token } = this.props

        fetchTemplateList(token)

        this.setState({ showTemplateBackgroundListModal: true })
    }

    closeTemplateBackgroundListModal() {
        this.setState({ showTemplateBackgroundListModal: false })
    }

    handleTemplateBackgroundListModalSubmit(templateId) {
        const { fetchTemplateBackgrounInformation, token } = this.props

        fetchTemplateBackgrounInformation(token, templateId)

        this.setState({ showTemplateBackgroundListModal: false })
    }

    // Modals - Import from Select Document
    openDocumentSelectModal(docType) {
        const { fetchDocumentList, token, selectedProject } = this.props

        fetchDocumentList(token, selectedProject._id, docType)

        this.setState({ showDocumentSelectModal: true })
    }

    closeDocumentSelectModal() {
        this.setState({ showDocumentSelectModal: false })
    }

    handleDocumentSelectModalSubmit(documentId) {
        const { fetchDocumentContent, token, selectedProject } = this.props

        fetchDocumentContent(token, selectedProject._id, documentId)

        this.setState({ showDocumentSelectModal: false })
    }

    handleImportOptionChange(field) {
        this.setState({
            [field]: !this.state[field]
        })
    }

    // Modals - Import Background Information from Project
    openProjectListModal() {
        const { fetchAllProjectList, token } = this.props

        fetchAllProjectList(token)

        this.setState({ showProjectListModal: true })
    }

    closeProjectListModal() {
        this.setState({ showProjectListModal: false })
    }

    handleProjectListModalSubmit(projectId) {
        const { fetchProjectBackgrounInformation, token } = this.props

        fetchProjectBackgrounInformation(token, projectId)

        this.setState({ showProjectListModal: false })
    }

    handleImportBackgroundMenuSelect(item) {
        switch (item.key) {
            case 'project':
                this.openProjectListModal()
                break
            case 'template':
                this.openTemplateBackgroundListModal()
                break
            default:
        }
    }

    handleImportMenuSelect(item) {
        switch (item.key) {
            case 'quotation':
            case 'budget-estimation':
                this.openDocumentSelectModal(item.key)
                break
            case 'template':
                this.openTemplateListModal()
                break
            case 'main-quotation':
                this.openQuotationItemListModal()
                break
            default:
        }
    }

    // General Handlers
    handleCreateNewMenuSelect(item) {
        const { selectedProject, location } = this.props
        const projectId = selectedProject._id
        const redirectTo = `/workdesk/project/${projectId}/document/new?type=${item.key}`
        if (location.pathname + location.search !== redirectTo)
            this.setState({ redirectTo })
    }

    handleNewDocumentTypeChange(e) {
        this.setState({ type: e.target.value, name: 'New ' + _.startCase(e.target.value) })
    }

    handleDocumentStatusChange(fieldName, checkedValues) {
        this.setState({ isDocumentContentChange: true, [fieldName]: true })
    }

    handleDocumentPaymentChange(paymentIdx, fieldName, bool, paidDate) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.payments[paymentIdx][fieldName] = !bool
        if (fieldName === 'paid' && newTermsAndConditions.payments[paymentIdx][fieldName] === true)
            newTermsAndConditions.payments[paymentIdx].paidAt = paidDate

        this.setState({ termsAndConditions: newTermsAndConditions, isDocumentContentChange: true })
    }

    handleSmartSearchFilterChange(field, value) {
        let newSmartSaerchFilter = _.cloneDeep(this.state.smartSaerchFilter)
        newSmartSaerchFilter[field] = value
        this.setState({ smartSaerchFilter: newSmartSaerchFilter })
    }

    // Background Information
    handleBackgroundInformationChange(field, e) {
        let newBackgroundInformation = _.cloneDeep(this.state.backgroundInformation)
        newBackgroundInformation[field] = e.target.value
        this.setState({ backgroundInformation: newBackgroundInformation, isProjectBackgroundChange: true })
    }

    handleBackgroundInformationValueChange(field, value) {
        let newBackgroundInformation = _.cloneDeep(this.state.backgroundInformation)
        newBackgroundInformation[field] = value
        this.setState({ backgroundInformation: newBackgroundInformation, isProjectBackgroundChange: true })
    }

    // Sections Item
    handleSectionItemFocus(sectionIdx, itemIdx, e) {
        const { fetchItemSmartSuggestionList, token, itemSmartSuggestionList } = this.props
        const { sections, smartSaerchFilter } = this.state
        const itemName = sections[sectionIdx].items[itemIdx].name
        if (itemName) {
            if (itemSmartSuggestionList.keyword !== itemName)
                fetchItemSmartSuggestionList(token, itemName, smartSaerchFilter)
        }
    }

    handleSectionItemSmartSelect(sectionIdx, itemIdx, selectedItem) {
        const { type, noticeSections, discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        const { basic_charge_quantity, basic_charge, unit_rate, unit } = selectedItem

        // newSections[sectionIdx].items[itemIdx].quantity = quantity
        newSections[sectionIdx].items[itemIdx].basic_charge_quantity = basic_charge_quantity
        newSections[sectionIdx].items[itemIdx].basic_charge = basic_charge
        newSections[sectionIdx].items[itemIdx].unit_rate = unit_rate
        newSections[sectionIdx].items[itemIdx].unit = unit

        this.setState({ grandTotal: getGrandTotal(type, newSections, noticeSections, discounts), sections: newSections, isDocumentContentChange: true })
    }

    handleSectionItemAdd(sectionIdx) {
        const { type, noticeSections, discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].items.push({
            name: '',
            quantity: 0,
            unit_rate: 0,
            unit: ''
        })

        this.setState({ grandTotal: getGrandTotal(type, newSections, noticeSections, discounts), sections: newSections, isDocumentContentChange: true })
    }

    handleSectionItemInsert(sectionIdx, itemIdx) {
        const { type, noticeSections, discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].items.splice(itemIdx, 0, {
            name: '',
            quantity: 0,
            unit_rate: 0,
            unit: ''
        })

        this.setState({ grandTotal: getGrandTotal(type, newSections, noticeSections, discounts), sections: newSections, isDocumentContentChange: true })
    }

    handleSectionItemRemove(sectionIdx, itemIdx) {
        const { type, noticeSections, discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].items.splice(itemIdx, 1)

        this.setState({ grandTotal: getGrandTotal(type, newSections, noticeSections, discounts), sections: newSections, isDocumentContentChange: true })
    }

    handleSectionItemChange(sectionIdx, itemIdx, field, e) {
        const { type, noticeSections, discounts } = this.state
        let newState = { isDocumentContentChange: true }
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].items[itemIdx][field] = e.target.type === 'checkbox' ? e.target.checked : e.target.value

        if (type !== 'working-progress') {
            newState.grandTotal = getGrandTotal(type, newSections, noticeSections, discounts)
        } else if (field === 'progress') {
            newSections[sectionIdx].items[itemIdx]['updated'] = true
        }

        newState.sections = newSections

        this.setState(newState)
    }

    handleSectionItemValueChange(sectionIdx, itemIdx, field, value) {
        const { type, noticeSections, discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].items[itemIdx][field] = value

        this.setState({ grandTotal: getGrandTotal(type, newSections, noticeSections, discounts), sections: newSections, isDocumentContentChange: true })
    }

    handleSectionItemImageChange(sectionIdx, itemIdx, url) {
        const { type } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].items[itemIdx].imageUrl = url

        if (type === 'working-progress') {
            newSections[sectionIdx].items[itemIdx].updated = true
        }

        this.setState({ sections: newSections, isDocumentContentChange: true })
    }

    // Sections
    handleSectionAdd() {
        const { type, noticeSections, discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        newSections.push({
            name: '',
            items: [],
            remarks: []
        })

        this.setState({ grandTotal: getGrandTotal(type, newSections, noticeSections, discounts), sections: newSections, isDocumentContentChange: true })
    }

    handleSectionRemove(sectionIdx) {
        const { type, noticeSections, discounts } = this.state
        let newSections = _.cloneDeep(this.state.sections)
        newSections.splice(sectionIdx, 1)

        this.setState({ grandTotal: getGrandTotal(type, newSections, noticeSections, discounts), sections: newSections, isDocumentContentChange: true })
    }

    handleSectionChange(sectionIdx, field, e) {
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx][field] = e.target.value
        this.setState({ sections: newSections, isDocumentContentChange: true })
    }

    handleSectionToggle(sectionIdx) {
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].toggled = !newSections[sectionIdx].toggled
        this.setState({ sections: newSections, isDocumentContentChange: true })
    }

    handleSectionRemarkAdd(sectionIdx) {
        let newSections = _.cloneDeep(this.state.sections)
        if (_.isEmpty(newSections[sectionIdx].remarks))
            newSections[sectionIdx].remarks = []
        newSections[sectionIdx].remarks.push('')

        this.setState({ sections: newSections, isDocumentContentChange: true })
    }

    handleSectionRemarkInsert(sectionIdx, remarkIdx) {
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].remarks.splice(remarkIdx, 0, '')

        this.setState({ sections: newSections, isDocumentContentChange: true })
    }

    handleSectionRemarkRemove(sectionIdx, remarkIdx) {
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].remarks.splice(remarkIdx, 1)

        this.setState({ sections: newSections, isDocumentContentChange: true })
    }

    handleSectionRemarkChange(sectionIdx, remarkIdx, e) {
        let newSections = _.cloneDeep(this.state.sections)
        newSections[sectionIdx].remarks[remarkIdx] = e.target.value

        this.setState({ sections: newSections, isDocumentContentChange: true })
    }

    // Notice Section
    handleNoticeSectionItemFocus(itemIdx, e) {
        const { fetchItemSmartSuggestionList, token, itemSmartSuggestionList } = this.props
        const { noticeSections, smartSaerchFilter } = this.state
        const itemName = noticeSections.items[itemIdx].name
        if (itemName) {
            if (itemSmartSuggestionList.keyword !== itemName)
                fetchItemSmartSuggestionList(token, itemName, smartSaerchFilter)
        }
    }

    handleNoticeSectionItemSmartSelect(itemIdx, selectedItem) {
        const { type, sections, discounts } = this.state
        let newNoticeSections = _.cloneDeep(this.state.noticeSections)
        const { basic_charge_quantity, basic_charge, unit_rate, unit } = selectedItem

        // newNoticeSections.items[itemIdx].quantity = quantity
        newNoticeSections.items[itemIdx].basic_charge_quantity = basic_charge_quantity
        newNoticeSections.items[itemIdx].basic_charge = basic_charge
        newNoticeSections.items[itemIdx].unit_rate = unit_rate
        newNoticeSections.items[itemIdx].unit = unit

        this.setState({ grandTotal: getGrandTotal(type, sections, newNoticeSections, discounts), noticeSections: newNoticeSections, isDocumentContentChange: true })
    }

    handleNoticeSectionItemAdd() {
        const { type, sections, discounts } = this.state
        let newNoticeSections = _.cloneDeep(this.state.noticeSections)
        newNoticeSections.items.push({
            name: '',
            quantity: 0,
            unit_rate: 0,
            unit: ''
        })

        this.setState({ grandTotal: getGrandTotal(type, sections, newNoticeSections, discounts), noticeSections: newNoticeSections, isDocumentContentChange: true })
    }

    handleNoticeSectionItemInsert(itemIdx) {
        const { type, sections, discounts } = this.state
        let newNoticeSections = _.cloneDeep(this.state.noticeSections)
        newNoticeSections.items.splice(itemIdx, 0, {
            name: '',
            quantity: 0,
            unit_rate: 0,
            unit: ''
        })

        this.setState({ grandTotal: getGrandTotal(type, sections, newNoticeSections, discounts), noticeSections: newNoticeSections, isDocumentContentChange: true })
    }

    handleNoticeSectionItemRemove(itemIdx) {
        const { type, sections, discounts } = this.state
        let newNoticeSections = _.cloneDeep(this.state.noticeSections)
        newNoticeSections.items.splice(itemIdx, 1)

        this.setState({ grandTotal: getGrandTotal(type, sections, newNoticeSections, discounts), noticeSections: newNoticeSections, isDocumentContentChange: true })
    }

    handleNoticeSectionItemChange(itemIdx, field, e) {
        const { type, sections, discounts } = this.state
        let newState = { isDocumentContentChange: true }
        let newNoticeSections = _.cloneDeep(this.state.noticeSections)
        newNoticeSections.items[itemIdx][field] = e.target.type === 'checkbox' ? e.target.checked : e.target.value

        if (type !== 'working-progress') {
            newState.grandTotal = getGrandTotal(type, sections, newNoticeSections, discounts)
        } else if (field === 'progress') {
            newNoticeSections.items[itemIdx]['updated'] = true
        }

        newState.noticeSections = newNoticeSections

        this.setState(newState)
    }

    handleNoticeSectionItemValueChange(itemIdx, field, value) {
        const { type, sections, discounts } = this.state
        let newNoticeSections = _.cloneDeep(this.state.noticeSections)
        newNoticeSections.items[itemIdx][field] = value

        this.setState({ grandTotal: getGrandTotal(type, sections, newNoticeSections, discounts), noticeSections: newNoticeSections, isDocumentContentChange: true })
    }

    handleNoticeSectionItemImageChange(itemIdx, url) {
        const { type } = this.state
        let newNoticeSections = _.cloneDeep(this.state.noticeSections)
        newNoticeSections.items[itemIdx].imageUrl = url

        if (type === 'working-progress') {
            newNoticeSections.items[itemIdx].updated = true
        }

        this.setState({ noticeSections: newNoticeSections, isDocumentContentChange: true })
    }

    handleNoticeSectionToggle() {
        let newNoticeSections = _.cloneDeep(this.state.noticeSections)
        newNoticeSections.toggled = !newNoticeSections.toggled
        this.setState({ noticeSections: newNoticeSections, isDocumentContentChange: true })
    }

    // Discounts
    handleDiscountAdd() {
        const { type, sections, noticeSections } = this.state
        let newDiscounts = _.cloneDeep(this.state.discounts)
        newDiscounts.push({
            name: '',
            amount: 0
        })

        this.setState({ grandTotal: getGrandTotal(type, sections, noticeSections, newDiscounts), discounts: newDiscounts, isDocumentContentChange: true })
    }

    handleDiscountRemove(discountIdx) {
        const { type, sections, noticeSections } = this.state
        let newDiscounts = _.cloneDeep(this.state.discounts)
        newDiscounts.splice(discountIdx, 1)

        this.setState({ grandTotal: getGrandTotal(type, sections, noticeSections, newDiscounts), discounts: newDiscounts, isDocumentContentChange: true })
    }

    handleDiscountChange(discountIdx, field, e) {
        const { type, sections, noticeSections } = this.state
        let newDiscounts = _.cloneDeep(this.state.discounts)
        newDiscounts[discountIdx][field] = e.target.value

        this.setState({ grandTotal: getGrandTotal(type, sections, noticeSections, newDiscounts), discounts: newDiscounts, isDocumentContentChange: true })
    }

    handleDiscountValueChange(discountIdx, field, value) {
        const { type, sections, noticeSections } = this.state
        let newDiscounts = _.cloneDeep(this.state.discounts)
        newDiscounts[discountIdx][field] = value

        this.setState({ grandTotal: getGrandTotal(type, sections, noticeSections, newDiscounts), discounts: newDiscounts, isDocumentContentChange: true })
    }

    // Terms and Conditions
    handleTNCPaymentAdd() {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)

        newTermsAndConditions.payments.push({
            name: '',
            amount: 0,
            description: '',
            paid: false,
            invoice_sent: false,
            receive_sent: false
        })

        this.setState({ termsAndConditions: newTermsAndConditions, isDocumentContentChange: true })
    }

    handleTNCPaymentRemove(paymentIdx) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.payments.splice(paymentIdx, 1)
        this.setState({ termsAndConditions: newTermsAndConditions, isDocumentContentChange: true })
    }
    handleTNCPaymentDateChange(paymentIdx, field, date, dateString) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.payments[paymentIdx][field] = date ? moment(dateString).startOf('day') : undefined
        this.setState({ termsAndConditions: newTermsAndConditions, isDocumentContentChange: true })
    }

    handleTNCPaymentChange(paymentIdx, field, e) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.payments[paymentIdx][field] = e.target.value
        this.setState({ termsAndConditions: newTermsAndConditions, isDocumentContentChange: true })
    }

    handleTNCPaymentNumberChange(paymentIdx, field, value) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.payments[paymentIdx][field] = value
        if (field === 'percentage') {
            newTermsAndConditions.payments[paymentIdx]['amount'] = +(this.state.grandTotal * value / 100).toFixed(1) || 0
        }

        this.setState({ termsAndConditions: newTermsAndConditions, isDocumentContentChange: true })
    }

    handleTNCSectionAdd() {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.sections.push({
            title: '',
            description: ''
        })
        this.setState({ termsAndConditions: newTermsAndConditions, isDocumentContentChange: true })
    }

    handleTNCSectionRemove(sectionIdx) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.sections.splice(sectionIdx, 1)
        this.setState({ termsAndConditions: newTermsAndConditions, isDocumentContentChange: true })
    }

    handleTNCSectionChange(sectionIdx, field, e) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions.sections[sectionIdx][field] = e.target.value
        this.setState({ termsAndConditions: newTermsAndConditions, isDocumentContentChange: true })
    }

    handleTNCFieldChange(field, e) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions[field] = e.target.value
        this.setState({ termsAndConditions: newTermsAndConditions, isDocumentContentChange: true })
    }

    handleTNCFieldValueChange(field, value) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions[field] = value
        this.setState({ termsAndConditions: newTermsAndConditions, isDocumentContentChange: true })
    }

    handleTNCFieldDateChange(field, date, dateString) {
        let newTermsAndConditions = _.cloneDeep(this.state.termsAndConditions)
        newTermsAndConditions[field] = date ? moment(dateString).startOf('day') : undefined
        this.setState({ termsAndConditions: newTermsAndConditions, isDocumentContentChange: true })
    }

    // Remarks Section
    handleRemarkAdd() {
        let newRemarks = _.cloneDeep(this.state.remarks)
        newRemarks.push({ name: 'New Remark', rows: [] })
        this.setState({ remarks: newRemarks, isDocumentContentChange: true })
    }

    handleRemarkToggle(remarkIdx) {
        let newRemarks = _.cloneDeep(this.state.remarks)
        newRemarks[remarkIdx].toggled = !newRemarks[remarkIdx].toggled
        this.setState({ remarks: newRemarks, isDocumentContentChange: true })
    }

    handleRemarkChange(remarkIdx, field, e) {
        let newRemarks = _.cloneDeep(this.state.remarks)
        newRemarks[remarkIdx][field] = e.target.value
        this.setState({ remarks: newRemarks, isDocumentContentChange: true })
    }

    handleRemarkRemove(remarkIdx) {
        let newRemarks = _.cloneDeep(this.state.remarks)
        newRemarks.splice(remarkIdx, 1)
        this.setState({ remarks: newRemarks, isDocumentContentChange: true })
    }

    handleRemarkContentAdd(remarkIdx) {
        let newRemarks = _.cloneDeep(this.state.remarks)
        newRemarks[remarkIdx].rows.push({ content: '' })
        this.setState({ remarks: newRemarks, isDocumentContentChange: true })
    }

    handleRemarkContentRemove(remarkIdx, contentIdx) {
        let newRemarks = _.cloneDeep(this.state.remarks)
        newRemarks[remarkIdx].rows.splice(contentIdx, 1)
        this.setState({ remarks: newRemarks, isDocumentContentChange: true })
    }

    handleRemarkContentChange(remarkIdx, contentIdx, field, e) {
        let newRemarks = _.cloneDeep(this.state.remarks)
        newRemarks[remarkIdx].rows[contentIdx][field] = e.target.value
        this.setState({ remarks: newRemarks, isDocumentContentChange: true })
    }

    handleRemarkContentDateChange(remarkIdx, contentIdx, field, date, dateString) {
        let newRemarks = _.cloneDeep(this.state.remarks)
        newRemarks[remarkIdx].rows[contentIdx][field] = date ? moment(dateString).startOf('day') : undefined
        this.setState({ remarks: newRemarks, isDocumentContentChange: true })
    }

    // Apendix Section
    handleAppendixItemAdd() {
        let newAppendix = _.cloneDeep(this.state.appendix)
        newAppendix.push({ imageUrl: '', description: '' })
        this.setState({ appendix: newAppendix, isDocumentContentChange: true })
    }

    handleAppendixItemRemove(itemIdx) {
        let newAppendix = _.cloneDeep(this.state.appendix)
        newAppendix.splice(itemIdx, 1)
        this.setState({ appendix: newAppendix, isDocumentContentChange: true })
    }

    handleAppendixItemChange(itemIdx, field, e) {
        let newAppendix = _.cloneDeep(this.state.appendix)
        if (typeof(e) === 'object') {
            newAppendix[itemIdx][field] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
        } else {
            newAppendix[itemIdx][field] = e
        }
        this.setState({ appendix: newAppendix, isDocumentContentChange: true })
    }

    ///////////////////////////////

    handleDocumentSave() {
        const { createProject, createDocument, updateDocumentContentWithBgInfo, updateDocumentContentWithoutBgInfo, updateProjectBgInfo, token, match, selectedProject, selectedProjectDocument } = this.props
        const { name, type, sent, confirmed, grandTotal, backgroundInformation, sections, noticeSections, discounts, termsAndConditions, remarks, appendix, isProjectBackgroundChange, isDocumentContentChange } = this.state

        const projectId = selectedProject._id
        const documentId = selectedProjectDocument._id

        // Document Id is defined = updating its content/background information
        if (match.params.documentId !== undefined) {
            if (isProjectBackgroundChange && isDocumentContentChange)
                updateDocumentContentWithBgInfo(token, projectId, backgroundInformation, documentId, { name, type, sent, confirmed, grandTotal, sections, noticeSections, discounts, termsAndConditions, remarks, appendix })
            else if (isDocumentContentChange && !isProjectBackgroundChange)
                updateDocumentContentWithoutBgInfo(token, projectId, documentId, { name, type, sent, confirmed, grandTotal, sections, noticeSections, discounts, termsAndConditions, remarks, appendix })
            else if (isProjectBackgroundChange && !isDocumentContentChange)
                updateProjectBgInfo(token, projectId, backgroundInformation)
            // Document Id is undefined and Project Id is defined = create a new document
        } else if (match.params.projectId !== undefined) {
            createDocument(token, projectId, { name, type, sent, confirmed, grandTotal, sections, noticeSections, discounts, termsAndConditions, remarks, appendix })
            // Doument Id is undefined and Project Id is undefined = create a new project + new document
        } else {
            createProject(token, backgroundInformation, { name, type, sent, confirmed, grandTotal, sections, noticeSections, discounts, termsAndConditions, remarks, appendix })
        }

        this.setState({ isProjectBackgroundChange: false, isDocumentContentChange: false })

    }

    handleDocumentExport() {
        const { exportDocument, token } = this.props
        exportDocument(token)
    }

    handleDocumentVoid() {
        const { voidDocument, token, selectedProject, selectedProjectDocument } = this.props
        const projectId = selectedProject._id
        const documentId = selectedProjectDocument._id

        voidDocument(token, projectId, documentId)
    }

    handleProjectDocumentDueUpdate(projectDue, documentDue) {
        const { updateProjectDue, updateDocumentDue, token, selectedProject, selectedProjectDocument } = this.props
        const projectId = selectedProject._id
        const documentId = selectedProjectDocument._id

        if (!_.isEqual(projectDue, moment(selectedProject.due)))
            updateProjectDue(token, projectId, projectDue)
        if (!_.isEqual(documentDue, moment(selectedProjectDocument.due)))
            updateDocumentDue(token, projectId, documentId, documentDue)
    }

    componentWillMount() {
        const { loadProject, fetchProjectDocument, fetchItemList, fetchUnitList, fetchAvailableContactPersonList, fetchLocationList, fetchEstateList, clearAvailableContactPersonList, token, selectedProject, match, location } = this.props
        const { projectId, documentId } = match.params

        // Set state of backgroundInformation if project is selected somewhere else, e.g: redirect from other page
        if (_.isEmpty(this.state.backgroundInformation) && !_.isEmpty(selectedProject)) {
            const { code, name, type, category, size, client_name, company_name, client_number, client_email, contact_person, handled_by, handled_by_name, handled_by_number, flat, floor, estate_name, site_location, site_address, due } = selectedProject
            this.setState({ backgroundInformation: { code, name, type, category, size, client_name, company_name, client_number, client_email, contact_person, handled_by, handled_by_name, handled_by_number, flat, floor, estate_name, site_location, site_address, due } })
        }

        // Fetch project data if project id is defined, e.g: direct access to the page
        if ((_.isEmpty(selectedProject) && projectId !== undefined) || (!_.isEmpty(selectedProject) && selectedProject._id !== projectId))
            loadProject(token, projectId)

        // Fetch document data if project id and document id is both defined
        if (projectId && documentId)
            fetchProjectDocument(token, projectId, documentId)

        if (!projectId)
            clearAvailableContactPersonList()
        else
            fetchAvailableContactPersonList(token, projectId)

        // Fetch list of item for item name suggestion
        fetchItemList(token)

        // Fetch list of unit for unit suggestion
        fetchUnitList(token)

        // Fetch list of location and estate for filter
        fetchLocationList(token)
        fetchEstateList(token)

        // Update the selectedKey to highlight the corresponding side menu item
        this.setState({ selectedKey: location.pathname })
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            match,
            location,
            loadProject,
            reloadProject,
            fetchProjectDocument,
            requestRedirect,
            token,
            selectedProject,
            selectedProjectDocument,
            importedBackgroundInformation,
            mainQuotation,
            importedTempalte,
            importedDocument,
            isProjectStatusUpdating,
            itemSmartSuggestionList,
        } = this.props
        const { grandTotal, backgroundInformation, smartSaerchFilter } = this.state
        const { projectId, documentId } = match.params

        if (prevState.grandTotal !== grandTotal) {
            this.updatePaymentAmount()
        }

        // Created New Project (Project ID: undefined -> Returned Project ID)
        if (prevProps.match.params.projectId !== projectId) {
            requestRedirect('')
            loadProject(token, projectId)
            this.setState({ isProjectBackgroundChange: false })
        }

        // Created New Document (Document ID: undefined -> Returned Document ID)
        if (prevProps.match.params.documentId !== documentId && documentId) {
            fetchProjectDocument(token, projectId, documentId)
            this.setState({ isDocumentContentChange: false })
        }

        // Create New Document
        if (prevProps.location.search !== location.search) {
            const query = parse(location.search.substr(1))

            this.setState({
                name: 'New ' + _.startCase(query.type),
                type: query.type,
                sent: false,
                confirmed: false,
                voided: false,
                createdAt: '',
                discounts: [],
                grandTotal: 0,
                sections: [],
                noticeSections: {
                    items: []
                },
                termsAndConditions: {
                    commencementDate: '',
                    workingPeriod: 0,
                    workingPeriodRemark: '',
                    payments: [],
                    sections: []
                },
                remarks: [],
                appendix: [],
                due: '',
                isProjectBackgroundChange: false,
                isDocumentContentChange: false,
                redirectTo: ''
            })
        }

        // Update the highlighted section when the pathname(document) is changed
        if (prevProps.location.pathname !== location.pathname)
            this.setState({ selectedKey: location.pathname })

        if (!_.isEqual(prevProps.selectedProject, selectedProject)) {
            const { code, name, type, category, size, client_name, company_name, client_number, client_email, contact_person, handled_by, handled_by_name, handled_by_number, flat, floor, estate_name, site_location, site_address, due } = selectedProject
            this.setState({ backgroundInformation: { code, name, type, category, size, client_name, company_name, client_number, client_email, contact_person, handled_by, handled_by_name, handled_by_number, flat, floor, estate_name, site_location, site_address, due } })
        }

        if (!_.isEqual(prevProps.selectedProjectDocument, selectedProjectDocument) && !_.isEmpty(selectedProjectDocument)) {
            const { name, type, created_at, sent, confirmed, voided, discounts, grand_total, sections, notice_section, terms_and_conditions, remarks, appendix, due } = selectedProjectDocument
            this.setState({ name, type, createdAt: created_at, sent, confirmed, voided, discounts, grandTotal: grand_total, sections, noticeSections: notice_section, termsAndConditions: terms_and_conditions, remarks, appendix, due })
        }

        if (prevProps.isProjectStatusUpdating !== isProjectStatusUpdating && prevProps.isProjectStatusUpdating && !isProjectStatusUpdating)
            reloadProject(token, projectId)

        if (!_.isEqual(prevProps.importedBackgroundInformation, importedBackgroundInformation)) {
            const { client_name, company_name, client_email, client_number, handled_by, handled_by_name, handled_by_number, category, type, size, estate_name, site_location, site_address, flat, floor } = importedBackgroundInformation
            this.setState({ backgroundInformation: { ...backgroundInformation, client_name, company_name, client_email, client_number, handled_by, handled_by_name, handled_by_number, category, type, size, estate_name, site_location, site_address, flat, floor }, isProjectBackgroundChange: true })
        }

        if (!_.isEqual(prevProps.mainQuotation, mainQuotation)) {
            let newMainQuotation = _.cloneDeep(mainQuotation)
            if (!_.isEmpty(newMainQuotation)) {
                _.map(newMainQuotation.sections, (section) => {
                    _.map(section.items, (item) => {
                        item.checked = false
                    })
                })
            }
            this.setState({ mainQuotation: newMainQuotation })
        }

        if (!_.isEqual(prevProps.importedTempalte, importedTempalte) && !_.isEmpty(importedTempalte)) {
            const { grandTotal, termsAndConditions, importContent, importTAndC } = this.state
            let { sections, discounts, grand_total, terms_and_conditions } = importedTempalte
            terms_and_conditions.payments = _.map(terms_and_conditions.payments, (payment) => ({ ...payment, amount: payment.percentage ? +(grandTotal * payment.percentage / 100).toFixed(1) : payment.amount }))
            let newState = {}
            if (importContent)
                newState = Object.assign(newState, { sections, discounts, grandTotal: grand_total })
            if (importTAndC)
                newState = Object.assign(newState, { termsAndConditions: { ...termsAndConditions, sections: terms_and_conditions.sections, payments: terms_and_conditions.payments } })
            if (!_.isEmpty(newState))
                newState = Object.assign(newState, { isDocumentContentChange: true })
            this.setState(newState)
        }

        if (!_.isEqual(prevProps.importedDocument, importedDocument) && !_.isEmpty(importedDocument)) {
            const { termsAndConditions, importContent, importTAndC } = this.state
            const { sections, discounts, grand_total, terms_and_conditions } = importedDocument
            let newState = {}
            if (importContent)
                newState = Object.assign(newState, { sections, discounts, grandTotal: grand_total })
            if (importTAndC)
                newState = Object.assign(newState, { termsAndConditions: { ...termsAndConditions, sections: terms_and_conditions.sections } })
            if (!_.isEmpty(newState))
                newState = Object.assign(newState, { isDocumentContentChange: true })
            this.setState(newState)
        }

        if (!_.isEqual(prevState.smartSaerchFilter, smartSaerchFilter) && !_.isEmpty(itemSmartSuggestionList)) {
            const { fetchItemSmartSuggestionList } = this.props
            fetchItemSmartSuggestionList(token, itemSmartSuggestionList.keyword, smartSaerchFilter)
        }
    }

    renderDocumentStatus(isAuthorized) {
        const { selectedProject, location, match } = this.props
        const { type, voided, confirmed, sent, termsAndConditions } = this.state
        const isMainQuotationExist = _.some(selectedProject.documents, { type: 'quotation', confirmed: true })
        const isLocked = _.isEmpty(match.params.documentId) || selectedProject.status === 'completed' || selectedProject.status === 'inactive' || voided || type === 'working-progress' || !isAuthorized || (isMainQuotationExist && type === 'quotation')
        const ImportMenu = (
            <Menu onSelect={this.handleImportBackgroundMenuSelect}>
                <MenuItem key="project">Other Project</MenuItem>
                <MenuItem key="template">Template</MenuItem>
            </Menu>
        )

        if (location.pathname === '/workdesk/project/new')
            return (
                <div className="document-status">
                        <div className="document-btn-gp">
                        <Dropdown overlay={ImportMenu} trigger={['click']}>
                            <Button type="primary">Import Background From...</Button>
                        </Dropdown>
                        {this.renderImportButton(location.pathname === '/workdesk/project/new')}
                    </div>
                    <div className="status-item">
                        <div className="label">Initial Document: </div>
                        <RadioGroup className="radio-gp" value={type} onChange={this.handleNewDocumentTypeChange.bind(this)}>
                            <Radio value='budget-estimation'>Budget Estimation</Radio>
                            <Radio value='quotation'>Quotation</Radio>
                        </RadioGroup>
                    </div>
                </div>
            )
        else
            return (
                <div className="document-status">
                    <div className="document-btn-gp">
                        {this.renderImportButton()}
                        { (type === 'quotation' || type === 'sub-quotation' || type === 'budget-estimation') && <TempalteExportModal onConfirm={(name) => this.handleTemplateExport(name)}/> }
                    </div>
                    <div className="status-item">
                        <div className="label">Status: </div>
                        <div className="checkbox-gp">
                            <label className={cx('checkbox-gp-item', { disabled: isLocked })}>
                                <IrreversibleCheckbox checked={sent} onChange={this.handleDocumentStatusChange.bind(this, 'sent')} disabled={isLocked}/>
                                <span>Sent to Client</span>
                            </label>
                            <label className={cx('checkbox-gp-item', { disabled: isLocked })}>
                                <IrreversibleCheckbox checked={confirmed} onChange={this.handleDocumentStatusChange.bind(this, 'confirmed')} disabled={isLocked || !sent}/>
                                <span>Client Confirmed</span>
                            </label>
                        </div>
                    </div>
                    <div className="status-item">
                        <div className="label">Invoice Sent: </div>
                        <PaymentBlock paymentList={termsAndConditions.payments} fieldName="invoice_sent" onClick={(paymentIdx, sent) => this.handleDocumentPaymentChange(paymentIdx, 'invoice_sent', sent)} disabled={!sent || !isAuthorized}/>
                    </div>
                    <div className="status-item">
                        <div className="label">Payment: </div>
                        <PaymentBlock paymentList={termsAndConditions.payments} fieldName="paid" onClick={(paymentIdx, paid, paidDate) => this.handleDocumentPaymentChange(paymentIdx, 'paid', paid, paidDate)} disabled={!sent || !isAuthorized}/>
                    </div>
                </div>
            )
    }

    renderProjectBackgrounSection(isAuthorized) {
        const { location, selectedProject, availableContactMemberList } = this.props
        const { backgroundInformation } = this.state

        const isNewProject = (location.pathname === '/workdesk/project/new')

        return (
            <TabPane tab="Background" key="1">
                <div className="tab-content-container">
                    <h4>Project Information</h4>
                    <BackgroundInformationForm 
                        isNewProject={isNewProject}
                        isAuthorized={isAuthorized}
                        status={selectedProject.status}
                        backgroundInformation={backgroundInformation}
                        memberList={availableContactMemberList}
                        onInputChange={(field, e) => this.handleBackgroundInformationChange(field, e)}
                        onInputValueChange={(field, value) => this.handleBackgroundInformationValueChange(field, value)}
                    />
                </div>
            </TabPane>
        )
    }

    renderDocumentContentSection() {
        const { removeItemName, token, selectedProject, itemList, unitList, itemSmartSuggestionList, locationList, estateList } = this.props
        const { sent, type, sections, noticeSections, discounts, smartSaerchFilter } = this.state

        return (
            <TabPane tab="Content" key="2">
                <div className="tab-content-container">
                    <DocumentContentForm
                        token={token}
                        status={selectedProject.status}
                        type={type}
                        isDocumentSent={sent}
                        sections={sections}
                        noticeSections={noticeSections}
                        discounts={discounts}
                        smartSaerchFilter={smartSaerchFilter}
                        locationList={locationList}
                        estateList={estateList}
                        onSmartSearchFilterChange={(field, value) => this.handleSmartSearchFilterChange(field, value)}
                        itemNameSuggestionList={itemList}
                        removeItemName={removeItemName}
                        unitSuggestionList={unitList}
                        itemSmartSuggestionList={itemSmartSuggestionList}
                        onSuggestionItemClick={(sectionIdx, itemIdx, selectedItem) => this.handleSectionItemSmartSelect(sectionIdx, itemIdx, selectedItem)}
                        onItemFocus={(sectionIdx, itemIdx, e) => this.handleSectionItemFocus(sectionIdx, itemIdx, e)}
                        onItemAdd={(sectionIdx) => this.handleSectionItemAdd(sectionIdx)}
                        onItemInsert={(sectionIdx, itemIdx) => this.handleSectionItemInsert(sectionIdx, itemIdx)}
                        onItemRemove={(sectionIdx, itemIdx) => this.handleSectionItemRemove(sectionIdx, itemIdx)}
                        onItemChange={(sectionIdx, itemIdx, field, e) => this.handleSectionItemChange(sectionIdx, itemIdx, field, e)}
                        onItemValueChange={(sectionIdx, itemIdx, field, value) => this.handleSectionItemValueChange(sectionIdx, itemIdx, field, value)}
                        onItemImageChange={(sectionIdx, itemIdx, url) => this.handleSectionItemImageChange(sectionIdx, itemIdx, url)}
                        onSectionAdd={() => this.handleSectionAdd()}
                        onSectionRemove={(sectionIdx) => this.handleSectionRemove(sectionIdx)}
                        onSectionChange={(sectionIdx, field, e) => this.handleSectionChange(sectionIdx, field, e)}
                        onSectionToggle={(sectionIdx) => this.handleSectionToggle(sectionIdx)}
                        onSectionRemarkAdd={(sectionIdx) => this.handleSectionRemarkAdd(sectionIdx)}
                        onSectionRemarkInsert={(sectionIdx, remarkIdx) => this.handleSectionRemarkInsert(sectionIdx, remarkIdx)}
                        onSectionRemarkRemove={(sectionIdx, remarkIdx) => this.handleSectionRemarkRemove(sectionIdx, remarkIdx)}
                        onSectionRemarkChange={(sectionIdx, remarkIdx, e) => this.handleSectionRemarkChange(sectionIdx, remarkIdx, e)}
                        onNoticeSuggestionItemClick={(itemIdx, selectedItem) => this.handleNoticeSectionItemSmartSelect(itemIdx, selectedItem)}
                        onNoticeSectionItemFocus={(itemIdx, e) => this.handleNoticeSectionItemFocus(itemIdx, e)}
                        onNoticeSectionItemAdd={() => this.handleNoticeSectionItemAdd()}
                        onNoticeSectionItemInsert={(itemIdx) => this.handleNoticeSectionItemInsert(itemIdx)}
                        onNoticeSectionItemRemove={(itemIdx) => this.handleNoticeSectionItemRemove(itemIdx)}
                        onNoticeSectionItemChange={(itemIdx, field, e) => this.handleNoticeSectionItemChange(itemIdx, field, e)}
                        onNoticeSectionItemValueChange={(itemIdx, field, value) => this.handleNoticeSectionItemValueChange(itemIdx, field, value)}
                        onNoticeSectionItemImageChange={(itemIdx, url) => this.handleNoticeSectionItemImageChange(itemIdx, url)}
                        onNoticeSectionToggle={() => this.handleNoticeSectionToggle()}
                        onDiscountAdd={() => this.handleDiscountAdd()}
                        onDiscountRemove={(discountIdx) => this.handleDiscountRemove(discountIdx)}
                        onDiscountChange={(discountIdx, field, e) => this.handleDiscountChange(discountIdx, field, e)}
                        onDiscountValueChange={(discountIdx, field, value) => this.handleDiscountValueChange(discountIdx, field, value)}
                    />
                </div>
            </TabPane>
        )
    }

    renderTermsAndConditionsSection() {
        const { selectedProject } = this.props
        const { sent, type, termsAndConditions } = this.state

        if (type !== 'budget-estimation' && type !== 'notice' && type !== 'working-progress' && type !== 'work-progress-report')
            return (
                <TabPane tab="T&C" key="3">
                    <div className="tab-content-container">
                        <h4>Terms and Conditions</h4>
                        <TermsAndConditionsForm
                            status={selectedProject.status}
                            type={type}
                            isDocumentSent={sent} 
                            termsAndConditions={termsAndConditions}
                            onFieldChange={(field, e) => this.handleTNCFieldChange(field, e)}
                            onFieldValueChange={(field, value) => this.handleTNCFieldValueChange(field, value)}
                            onFieldDateChange={(field, date, dateString) => this.handleTNCFieldDateChange(field, date, dateString)}
                            onPaymentAdd={() => this.handleTNCPaymentAdd()}
                            onPaymentRemove={(paymentIdx) => this.handleTNCPaymentRemove(paymentIdx)}
                            onPaymentChange={(paymentIdx, field, e) => this.handleTNCPaymentChange(paymentIdx, field, e)}
                            onPaymentNumberChange={(paymentIdx, field, value) => this.handleTNCPaymentNumberChange(paymentIdx, field, value)}
                            onPaymentDateChange={(paymentIdx, field, date, dateString) => this.handleTNCPaymentDateChange(paymentIdx, field, date, dateString)}
                            onSectionAdd={() => this.handleTNCSectionAdd()}
                            onSectionRemove={(sectionIdx) => this.handleTNCSectionRemove(sectionIdx)}
                            onSectionChange={(sectionIdx, field, e) => this.handleTNCSectionChange(sectionIdx, field, e)}
                        />
                    </div>
                </TabPane>
            )
    }

    renderPaymentStatusSection(isAuthorized) {
        const { selectedProject } = this.props
        const { sent, type, grandTotal, termsAndConditions } = this.state

        if (type === 'quotation' || type === 'sub-quotation')
            return (
                <TabPane tab="Invoice" key="4">
                    <div className="tab-content-container">
                        <PaymentInvoiceTable
                            isAuthorized={isAuthorized}
                            status={selectedProject.status}
                            type={type}
                            isDocumentSent={sent} 
                            payments={termsAndConditions.payments}
                            grandTotal={grandTotal}
                            onPaymentStatusChange={(paymentIdx, fieldName, bool, paidDate) => this.handleDocumentPaymentChange(paymentIdx, fieldName, bool, paidDate)}
                        />
                    </div>
                </TabPane>
            )
    }

    renderRemarkSection() {
        const { selectedProject } = this.props
        const { sent, voided, type, remarks } = this.state

        if (type === 'work-progress-report')
            return (
                <TabPane tab="Remarks" key="5">
                    <div className="tab-content-container">
                        <h4>Remarks</h4>
                        <RemarksForm
                            status={selectedProject.status}
                            type={type}
                            isDocumentSent={sent} 
                            isDocumentVoided={voided}
                            remarks={remarks}
                            onRemarkAdd={() => this.handleRemarkAdd()}
                            onRemarkToggle={(remarkIdx) => this.handleRemarkToggle(remarkIdx)}
                            onRemarkRemove={(remarkIdx) => this.handleRemarkRemove(remarkIdx)}
                            onRemarkChange={(remarkIdx, field, e) => this.handleRemarkChange(remarkIdx, field, e)}
                            onRemarkContentAdd={(remarkIdx) => this.handleRemarkContentAdd(remarkIdx)}
                            onRemarkContentRemove={(remarkIdx, contentId) => this.handleRemarkContentRemove(remarkIdx, contentId)}
                            onRemarkContentChange={(remarkIdx, contentId, field, e) => this.handleRemarkContentChange(remarkIdx, contentId, field, e)}
                            onRemarkContentDateChange={(remarkIdx, contentId, field, date, dateString) => this.handleRemarkContentDateChange(remarkIdx, contentId, field, date, dateString)}
                        />
                    </div>
                </TabPane>
            )
    }

    renderAppendixSection() {
        const { selectedProject } = this.props
        const { type, sent, sections, noticeSections, appendix } = this.state

        return (
            <TabPane tab="Appendix" key="6">
                <div className="tab-content-container">
                    <AppendixList
                        status={selectedProject.status}
                        type={type}
                        isDocumentSent={sent} 
                        sectionsList={sections}
                        noticeSection={noticeSections}
                        appendix={appendix}
                        onAppendixItemAdd={() => this.handleAppendixItemAdd()}
                        onAppendixItemRemove={(itemIdx) => this.handleAppendixItemRemove(itemIdx)}
                        onAppendixItemChange={(itemIdx, field, e) => this.handleAppendixItemChange(itemIdx, field, e)}
                        onItemChange={(sectionIdx, itemIdx, field, e) => this.handleSectionItemChange(sectionIdx, itemIdx, field, e)}
                        onNoticeSectionItemChange={(itemIdx, field, e) => this.handleNoticeSectionItemChange(itemIdx, field, e)}
                    />
                </div>
            </TabPane>
        )
    }

    renderCreateMenu() {
        const { selectedProject } = this.props
        const isDocumentConfirmed = selectedProject.status !== 'proposed'
        const lastVO = _.findLast(selectedProject.documents, { type: 'variation-order' })
        const isVOLocked = lastVO && lastVO.sent

        return (
            <Menu onSelect={this.handleCreateNewMenuSelect.bind(this)}>
                <MenuItem key="quotation" disabled={isDocumentConfirmed}>
                    Quotation
                </MenuItem>
                <MenuItem key="budget-estimation" disabled={isDocumentConfirmed}>
                    Budget Estimation
                </MenuItem>
                <MenuItem key="sub-quotation" disabled={!isDocumentConfirmed}>
                    Sub-quotation
                </MenuItem>
                <MenuItem key="notice" disabled={!isDocumentConfirmed || isVOLocked}>
                    Notice
                </MenuItem>
             </Menu>
        )
    }

    renderImportButton(isNew) {
        const { type, sent } = this.state
        let menuItemList = []

        if (isNew) {
            switch (type) {
                case 'budget-estimation':
                    menuItemList = [
                        { label: 'Template', value: 'template' },
                    ]
                    break
                case 'quotation':
                    menuItemList = [
                        { label: 'Template', value: 'template' },
                    ]
                    break
                default:
                    menuItemList = []
            }

            const ImportMenu = (
                <Menu onClick={this.handleImportMenuSelect}>
                {
                    _.map(menuItemList, (menuItem, idx) => 
                        <MenuItem key={menuItem.value}>
                            {menuItem.label}
                        </MenuItem>
                    )
                }
            </Menu>
            )

            if (menuItemList.length !== 0)
                return (
                    <Dropdown overlay={ImportMenu} trigger={['click']}>
                        <Button type="primary">Import Content From...</Button>
                    </Dropdown>
                )
        } else {
            switch (type) {
                case 'budget-estimation':
                    menuItemList = [
                        { label: 'Template', value: 'template' },
                        { label: 'Previous Quotation', value: 'quotation' }
                    ]
                    break
                case 'quotation':
                    menuItemList = [
                        { label: 'Budget Estimation', value: 'budget-estimation' },
                        { label: 'Template', value: 'template' },
                        { label: 'Previous Quotation', value: 'quotation' }
                    ]
                    break
                case 'sub-quotation':
                    menuItemList = [{ label: 'Template', value: 'template' }]
                    break
                case 'notice':
                    menuItemList = [{ label: 'Main Quotation', value: 'main-quotation' }]
                    break
                default:
                    menuItemList = []
            }

            const ImportMenu = (
                <Menu onClick={this.handleImportMenuSelect}>
                {
                    _.map(menuItemList, (menuItem, idx) => 
                        <MenuItem key={menuItem.value}>
                            {menuItem.label}
                        </MenuItem>
                    )
                }
            </Menu>
            )

            if (!sent && menuItemList.length !== 0)
                return (
                    <Dropdown overlay={ImportMenu} trigger={['click']}>
                        <Button type="primary">Import From...</Button>
                    </Dropdown>
                )
        }
    }

    render() {
        const { userId, userType, allProjectList, documentList, templateList, selectedProject, selectedProjectDocument, projectSummary, redirectRequest, locationList, estateList, loadingStatus } = this.props
        const { redirectTo, selectedKey, type, name, createdAt, sent, voided, sections, noticeSections, showTemplateListModal, showProjectListModal, showQuotationItemListModal, showDocumentSelectModal, showTemplateBackgroundListModal, mainQuotation, importContent, importTAndC, isProjectBackgroundChange, isDocumentContentChange, isMenuOpened } = this.state

        const { created_by, members, contact_person } = selectedProject
        const isAuthorized = created_by === userId || _.find(members, { member_id: userId, able_to_create: true }) || contact_person === userId || userType === 'admin'
        const templateParentColumns = [
            { title: 'Template Name', dataIndex: 'name', key: 'name', width: 300 },
            { title: 'Estate Name', dataIndex: 'estate_name', key: 'estate_name', width: 250, render: data => data || 'N/A' },
            { title: 'Type', dataIndex: 'type', key: 'type', width: 150, render: data => data || 'N/A' },
            { title: 'Size', dataIndex: 'size', key: 'size', width: 100, render: data => data || 'N/A' },
            { title: 'Due Date', dataIndex: 'due', key: 'due', width: 100, render: due => due ? moment(due).format('DD/MM/YYYY') : 'N/A' }
        ]
        const projectListParentColumns = [
            { title: 'Project Name', dataIndex: 'name', key: 'name', width: 300 },
            { title: 'Estate Name', dataIndex: 'estate_name', key: 'estate_name', width: 250, render: data => data || 'N/A' },
            { title: 'Type', dataIndex: 'type', key: 'type', width: 150, render: data => data || 'N/A' },
            { title: 'Size', dataIndex: 'size', key: 'size', width: 100, render: data => data || 'N/A' }
        ]
        let voidBtn = null
        let generateReportBtn = null
        let exportBtn = null

        if (type === 'variation-order' || type === 'work-progress-report') {
            if (voided)
                voidBtn = (<IrreversibleButton className="cheer-btn" disabled={ true } btnText="Voided" />)
            else
                voidBtn = (<IrreversibleButton className="void-btn cheer-btn" disabled={type === 'variation-order' && !selectedProjectDocument.sent} onConfirm={this.handleDocumentVoid} btnText="Void"/>)
        }

        if (type === 'working-progress') {
            generateReportBtn = <GenerateWPReportModal 
                                    sections={sections} 
                                    noticeSection={noticeSections}
                                    onConfirm={(newSections, newNoticeSections) => this.handleGenerateWPReportModalSubmit(newSections, newNoticeSections)} 
                                />
        } else {
            exportBtn = <ExportModal
                            loadingStatus={loadingStatus}
                            dataSource={selectedProject.documents}
                            onExport={(projectId, documentId, type, paymentId) => this.handlePDFExport(projectId, documentId, type, paymentId)}
                        />
        }

        if (redirectRequest !== '')
            return <Redirect to={redirectRequest} />
        else if (redirectTo !== '')
            return <Redirect to={redirectTo}/>
        else
            return (
                <div className="ProjectDocumentPage">
                    {this.renderDocumentStatus(isAuthorized)}
                    <div className="document-panel">
                        <Row gutter={8}>
                            <Col xs={{ span: 24 }} lg={{ span: 3 }}>
                                <div className="menu-container">
                                    <div className="toggle-btn" onClick={(e) => this.setState({ isMenuOpened: !isMenuOpened })}>
                                        Document List{' '}
                                        <Icon type={isMenuOpened ? 'up' : 'down'} />
                                    </div>
                                {
                                    !(location.pathname === '/workdesk/project/new') ?
                                    <Menu 
                                        className={cx('side-menu', { collapsed: isMenuOpened })}
                                        selectedKeys={[selectedKey]}
                                    >
                                        {
                                            _.map(selectedProject.documents, (doc, docIdx) => {
                                                return (
                                                    <MenuItem key={`/workdesk/project/${selectedProject._id}/document/${doc._id}`}>
                                                        <NavLink to={`/workdesk/project/${selectedProject._id}/document/${doc._id}`} activeClassName="active-link">
                                                            {
                                                                doc.voided ? 
                                                                <del>{doc.name}</del> :
                                                                doc.name
                                                            }
                                                        </NavLink>
                                                    </MenuItem>
                                                )
                                            })
                                        }
                                    </Menu> :
                                    <p className="empty-menu-msg">Not Available for New Project</p>
                                }
                                {
                                    !(location.pathname === '/workdesk/project/new') &&
                                    <Dropdown overlay={this.renderCreateMenu()} trigger={['click']}>
                                        <Button type="primary" className="cheer-btn">Add</Button>
                                    </Dropdown>
                                }
                                {
                                    !(location.pathname === '/workdesk/project/new') &&
                                    <ProjectSummaryModal
                                        dataSource={projectSummary}
                                        onOpen={this.handleProjectSummaryModalOpen}
                                    />
                                }
                                </div>
                            </Col>
                            <Col xs={{ span: 24 }} lg={{ span: 18 }} >
                                <div className="main-body">
                                    <h3 className="document-name">
                                        {name}
                                        {sent && (
                                            <Tooltip placement="top" title="This document is locked.">
                                                <Icon type="lock" />
                                            </Tooltip>
                                        )}
                                    </h3>
                                    <p className="document-info">{ createdAt ? `Created at ${moment(createdAt).format('DD-MM-YYYY')}` : ''}</p>
                                    <Tabs type="card" defaultActiveKey={(location.pathname === '/workdesk/project/new') ? "1" : "2"} >
                                        {this.renderProjectBackgrounSection(isAuthorized)}
                                        {this.renderDocumentContentSection()}
                                        {this.renderTermsAndConditionsSection()}
                                        {this.renderPaymentStatusSection(isAuthorized)}
                                        {this.renderRemarkSection()}
                                        {this.renderAppendixSection()}
                                    </Tabs>
                                </div>
                            </Col>
                            <Col xs={{ span: 24 }} lg={{ span: 3 }}>
                                <div className="btn-container">
                                    <DueDateModal
                                        projectDue={selectedProject.due}
                                        documentDue={selectedProjectDocument.due}
                                        onConfirm={(projectDue, documentDue) => this.handleProjectDocumentDueUpdate(projectDue, documentDue)}
                                    />
                                    { exportBtn }
                                    { generateReportBtn }
                                    { voidBtn }
                                    <Button className={cx('cheer-btn', {changed: isProjectBackgroundChange || isDocumentContentChange})} type="primary" size="large" onClick={this.handleDocumentSave}>Save</Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <NavLink to="/workdesk">
                        <div className="home-btn">
                            <Tooltip placement="top" title="Home">
                                    <Icon type="home" />
                            </Tooltip>
                        </div>
                    </NavLink>
                    <QuotationItemListModal
                        visible={showQuotationItemListModal}
                        onCancel={this.closeQuotationItemListModal}
                        modalBtnText="Import"
                        mainQuotation={mainQuotation}
                        onItemCheck={(sectionIdx, itemIdx) => this.handleMainQuotationItemCheck(sectionIdx, itemIdx)}
                        onSubmit={this.handleQuotationItemListSubmit}
                    />
                    <QSTableSelectImportModal
                        visible={showTemplateListModal}
                        locationList={locationList}
                        estateList={estateList}
                        importContent={importContent}
                        importTAndC={importTAndC}
                        onCheckboxChange={(field) => this.handleImportOptionChange(field)}
                        onCancel={this.closeTemplateListModal}
                        onConfirm={(templateId) => this.handleTemplateModalSubmit(templateId)}
                        listParentColumns={templateParentColumns}
                        listDataSource={templateList}
                        infoText="Please choose a template to import:"
                        popconfirmText="This action will overwrite all the current document contents, are you sure?"
                        modalBtnText="Import"
                    />
                    <DocumentSelectModal
                        documentList={documentList}
                        visible={showDocumentSelectModal}
                        importContent={importContent}
                        importTAndC={importTAndC}
                        onCheckboxChange={(field) => this.handleImportOptionChange(field)}
                        onCancel={this.closeDocumentSelectModal}
                        onConfirm={(documentId) => this.handleDocumentSelectModalSubmit(documentId)}
                        modalBtnText="Import"
                    />
                    <QSTableSelectImportModal
                        visible={showProjectListModal}
                        locationList={locationList}
                        estateList={estateList}
                        onCancel={this.closeProjectListModal}
                        onConfirm={(projectId) => this.handleProjectListModalSubmit(projectId)}
                        listParentColumns={projectListParentColumns}
                        listDataSource={allProjectList}
                        infoText="Please choose a project to import:"
                        popconfirmText="This action will overwrite all the current background information, are you sure?"
                        modalBtnText="Import"
                    />
                    <QSTableSelectImportModal
                        visible={showTemplateBackgroundListModal}
                        locationList={locationList}
                        estateList={estateList}
                        onCancel={this.closeTemplateBackgroundListModal}
                        onConfirm={(templateId) => this.handleTemplateBackgroundListModalSubmit(templateId)}
                        listParentColumns={templateParentColumns}
                        listDataSource={templateList}
                        infoText="Please choose a template to import:"
                        popconfirmText="This action will overwrite all the current background information, are you sure?"
                        modalBtnText="Import"
                    />
                </div>
            )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        userId: state.auth.userId,
        userType: state.auth.userType,
        loadingStatus: state.app.loadingStatus,
        selectedProject: state.app.selectedProject,
        isProjectStatusUpdating: state.app.isProjectStatusUpdating,
        locationList: state.app.locationList,
        estateList: state.app.estateList,
        selectedProjectDocument: state.projectDocumentPage.selectedProjectDocument,
        importedBackgroundInformation: state.projectDocumentPage.importedBackgroundInformation,
        mainQuotation: state.projectDocumentPage.mainQuotation,
        documentList: state.projectDocumentPage.documentList,
        importedDocument: state.projectDocumentPage.importedDocument,
        importedTempalte: state.projectDocumentPage.importedTempalte,
        itemList: state.projectDocumentPage.itemList,
        unitList: state.projectDocumentPage.unitList,
        availableContactMemberList: state.projectDocumentPage.availableContactMemberList,
        itemSmartSuggestionList: state.projectDocumentPage.itemSmartSuggestionList,
        projectSummary: state.projectDocumentPage.projectSummary,
        redirectRequest: state.projectDocumentPage.redirectRequest,
        templateList: state.templateListPage.templateList,
        allProjectList: state.projectDocumentPage.allProjectList
    }
}

export default connect(mapStateToProps, actions)(ProjectDocumentPage)


// WEBPACK FOOTER //
// ./src/ProjectDocumentPage/ProjectDocumentPage.js